import { MAP_API_KEY, REACT_APP_OSM_API_URL } from "./apiConfig";
import axiosClient from "./axiosClient";

const searchLocation = (keyword) => {
    console.log(`osmURL  ${keyword}  API =${REACT_APP_OSM_API_URL}`)
    try {
      return axiosClient.get(`/search`, {
        baseURL: REACT_APP_OSM_API_URL,
        params: {
            q: keyword,
            format: 'jsonv2'
        },
      }).then(response => {
        console.log(`searchLocation ${JSON.stringify(response)}`)
        return response        
      }).catch(e => {
        return e;
      });
    } catch (e) {      
      return e;
    }
};

const searchLocationMap4d = (location) => {
  const url = `https://api.map4d.vn/sdk/v2`
  console.log(`url  ${location}  API =${MAP_API_KEY}`)
  try {
    return axiosClient.get(`/geocode`, {
      baseURL: url,
      params: {
        key: MAP_API_KEY,
          location: location
      },
    }).then(response => {
      console.log(`searchLocation ${JSON.stringify(response)}`)
      return response        
    }).catch(e => {
      return e;
    });
  } catch (e) {      
    return e;
  }
};

const OpenStreetMapApi = {
    searchLocation,
    searchLocationMap4d
}
export default OpenStreetMapApi;